export default {
      id: "excel-usage",
      viewBox: "0 0 18.357 17.209",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#excel",
      toString: function () {
        return this.url;
      }
    }